import type { CityConfig } from "../city-template/types";

export const greeleyConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Greeley",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "greeley",
  route: "/greeley",
  title: "Emergency Passport Greeley, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Greeley, Colorado — as fast as 24 hours. Same-day courier processing for Greeley, Evans, Windsor, and all Weld County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Greeley, CO",
  heroSubtitle: "UNC study abroad trip coming up and your passport is expired? JBS corporate travel to South America with last-minute passport issues? We help Greeley residents — from UNC students and faculty to Weld County agricultural professionals to west Greeley families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Greeley%20Colorado%20downtown%20historic%20district%20with%20tree%20lined%208th%20Avenue%2C%20classic%20brick%20buildings%20from%20the%20early%201900s%20under%20bright%20Colorado%20blue%20sky%2C%20the%20University%20of%20Northern%20Colorado%20campus%20with%20modern%20and%20historic%20buildings%2C%20wide%20open%20plains%20landscape%20with%20distant%20Rocky%20Mountain%20foothills%2C%20warm%20golden%20prairie%20light%2C%20professional%20architectural%20photography%2C%20no%20visible%20text%20or%20people%2C%20clean%20wide%20angle%20view&width=1800&height=700&seq=greeley-hero-001&orientation=landscape",
  heroImageAlt: "Greeley Colorado downtown historic district with UNC campus and Rocky Mountain backdrop",
  geoPosition: "40.4233;-104.7091",
  geoPlacename: "Greeley, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 60 miles south via US-85 and I-76 — about 1 hour 15 minutes",
  },
  nearbyCitiesZips: [
    { name: "Greeley", zips: "80631, 80632, 80633, 80634, 80638, 80639" },
    { name: "Evans", zips: "80620, 80634" },
    { name: "Windsor", zips: "80528, 80550" },
    { name: "Johnstown", zips: "80534" },
    { name: "Milliken", zips: "80543" },
    { name: "La Salle", zips: "80645" },
    { name: "Eaton", zips: "80615" },
    { name: "Ault", zips: "80610" },
    { name: "Severance", zips: "80546" },
    { name: "Pierce", zips: "80650" },
    { name: "Kersey", zips: "80644" },
    { name: "Platteville", zips: "80651" },
    { name: "Fort Lupton", zips: "80621" },
    { name: "Loveland", zips: "80537, 80538" },
    { name: "Fort Collins", zips: "80521, 80523, 80524, 80525, 80526" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent UNC study abroad, JBS business travel, and Weld County international departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — no need to drive 60 miles to Denver" },
    { icon: "ri-global-line", title: "UNC Student & Faculty Service", desc: "Specialized help for University of Northern Colorado international programs" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Greeley or Evans" },
  ],
  internalLinks: [
    { name: "Expedited passport in Fort Collins, CO", route: "/fort-collins" },
    { name: "Emergency passport help in Loveland, CO", route: "/loveland" },
    { name: "Fast passport renewal in Denver, CO", route: "/denver" },
    { name: "Urgent passport services for Windsor and Severance", route: "/greeley" },
    { name: "Colorado passport services overview", route: "/colorado" },
    { name: "Passport courier services in Evans and La Salle", route: "/greeley" },
    { name: "Fast Passport Center — Cheyenne, WY office", route: "/cheyenne" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Greeley remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Greeley's location — 60 miles from the Colorado Passport Agency — makes our courier service especially valuable. Skip the drive down US-85 and let us handle everything. The closest Fast Passport Center physical office is located at 2020 Carey Ave, Cheyenne, WY 82001 — about 55 minutes north via US-85.",
  fpcOfficeAddress: "370 17th St, Denver, CO 80202",
  fpcOfficeDistance: "Serving all of Weld County, from Greeley to Fort Lupton and beyond",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Greeley and all Weld County. From the UNC campus and downtown Greeley to the residential neighborhoods of west Greeley, from Evans to the growing communities of Windsor and Severance — we serve every corner of northern Colorado.",
  nearbyCitiesIntro: "We serve Greeley and all nearby Weld County communities including Evans, Windsor, Johnstown, Milliken, La Salle, Eaton, Ault, Severance, Pierce, Kersey, Platteville, and Fort Lupton. We also serve Loveland and Fort Collins in neighboring Larimer County.",
  howItWorksIntro: "Most Greeley travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 60 miles to Denver on US-85.",
  mistakesIntro: "Greeley is home to UNC's international programs and the JBS corporate headquarters with global business travel. Here are the most common passport mistakes we see from Greeley-area travelers.",
  testimonialsIntro: "Greeley travelers — from UNC students heading abroad to Weld County professionals on international business — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Greeley, CO? Here are the most common ones we hear from Weld County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive required — ship from Greeley", "Perfect for UNC study abroad and JBS business travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Denver (1 hour 15 min via US-85/I-76)", "Subject to availability — no guarantees"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Greeley travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service available without the drive to Denver.",
      bullets: ["24–48 hour turnaround available", "UNC study abroad and JBS corporate travel expertise", "Weld County international departure support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Greeley adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Weld County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Greeley residents and Weld County families — including UNC freshmen heading abroad for the first time.",
      bullets: ["Acceptance facility scheduling in Greeley or Evans", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Greeley residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Greeley and Weld County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Greeley and Weld County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Greeley CO", description: "Urgent passport processing for Greeley Colorado travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Greeley CO", description: "Fast passport renewal for Greeley Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Greeley CO", description: "New passport application services for Greeley Colorado residents applying for their first passport." },
    { name: "Child Passport Greeley CO", description: "Minor passport services for Greeley Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "Greeley, CO — UNC Campus Area",
      rating: 5,
      text: "UNC semester abroad in Spain and my passport expired the week before departure. Fast Passport Center renewed it in 2 days. Shipped from the UPS Store on 10th Street and had my new passport before my flight from DIA. Incredible service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Carlos R.",
      location: "Evans, CO",
      rating: 5,
      text: "JBS sent me to Brazil for two months and I needed a visa fast. Fast Passport Center expedited my renewal in 3 days and helped with all the documentation. The whole process was streamlined and professional.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Linda K.",
      location: "Windsor, CO",
      rating: 5,
      text: "Family reunion in Germany with 8 days notice. My passport and both kids' passports needed renewal. Fast Passport Center handled all three in 5 business days. Saved our family trip.",
      service: "Family Passport Bundle",
    },
    {
      name: "Dr. James T.",
      location: "Greeley, CO — West",
      rating: 5,
      text: "Academic conference in Tokyo with 10 days notice. My passport was in good shape but needed renewal for Japanese entry requirements. Fast Passport Center got it done in 4 days. Highly recommend for UNC faculty.",
      service: "Expedited Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "greeley-1",
      name: "Greeley Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "925 11th Ave",
      city: "Greeley",
      state: "CO",
      zip: "80631",
      phone: "(970) 352-1431",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Greeley, near Lincoln Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Greeley acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient for downtown and UNC campus area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "greeley-2",
      name: "Evans Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3700 Golden St",
      city: "Evans",
      state: "CO",
      zip: "80620",
      phone: "(970) 339-5541",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Evans, approximately 5 miles south of downtown Greeley",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Evans and south Greeley residents. Less crowded than the main Greeley facility.",
      icon: "ri-mail-line",
    },
    {
      id: "greeley-3",
      name: "Windsor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6350 Westwood Blvd",
      city: "Windsor",
      state: "CO",
      zip: "80528",
      phone: "(970) 686-2561",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Windsor, approximately 12 miles southwest of Greeley",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Windsor, Severance, and western Weld County. Ample parking and modern facility.",
      icon: "ri-mail-line",
    },
    {
      id: "greeley-4",
      name: "Fort Lupton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "305 Denver Ave",
      city: "Fort Lupton",
      state: "CO",
      zip: "80621",
      phone: "(303) 857-4201",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fort Lupton, approximately 20 miles south of Greeley",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Weld County. Good alternative for Fort Lupton, Platteville, and surrounding communities.",
      icon: "ri-mail-line",
    },
    {
      id: "greeley-5",
      name: "Weld County Clerk & Recorder",
      type: "County Clerk Passport Acceptance",
      address: "1402 N 17th Ave",
      city: "Greeley",
      state: "CO",
      zip: "80631",
      phone: "(970) 304-6530",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Greeley, near UNC campus on 17th Avenue",
      website: "https://www.weld.gov/",
      websiteLabel: "Weld County Clerk",
      notes: "County clerk passport acceptance with extended morning hours. Convenient for UNC students and faculty. Appointment recommended.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 1hr 15min drive to Denver via US-85/I-76", fpc: "No — ship from Greeley" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Highway Travel", agency: "US-85 and I-76 traffic — variable", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-line",
      title: "Waiting Until UNC Deadlines",
      description: "UNC study abroad application deadlines coincide with peak passport demand. Start expedited service at least 4 weeks before your program start date. Routine processing takes 8–11 weeks — too long for most study abroad timelines.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services in Greeley sometimes produce photos for student IDs rather than passports. Passport photos must be exactly 2×2 inches on a white background — no exceptions.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Greeley Main Post Office appointments fill during UNC semester starts. Book 1–2 weeks ahead, especially during August–September and January.",
    },
    {
      icon: "ri-passport-line",
      title: "UNC Students Using Expired Passports",
      description: "Many UNC students discover their childhood passport expired years ago right before their study abroad semester. Check your passport validity the moment you're accepted into a program.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Visa Requirements",
      description: "JBS and other Weld County businesses sending employees to South America often need both a valid passport AND a business visa. Verify visa requirements early — some consulates take weeks.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Assuming DIA Is the Only Option",
      description: "Many Greeley travelers fly out of DIA (60 miles south). But remember — you need your passport days BEFORE your flight, not at the airport. Plan accordingly.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Greeley or Weld County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Greeley, Evans, or Windsor." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Weld County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no US-85 drive to Denver required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Greeley address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Greeley, CO?", a: "Fast Passport Center offers emergency passport processing in Greeley, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 60-mile drive on US-85 to the Colorado Passport Agency." },
    { q: "Does Greeley have its own passport agency?", a: "No — Greeley does not have a regional passport agency. The nearest is the Colorado Passport Agency (60 miles south via US-85 and I-76). Fast Passport Center's courier service means Greeley residents never need to deal with the drive." },
    { q: "Can you help UNC students with study abroad passports?", a: "Absolutely. Fast Passport Center specializes in helping University of Northern Colorado students get passports for study abroad programs. We understand academic timelines and can coordinate expedited processing to match your program start date. We also serve Aims Community College students." },
    { q: "What if I work at JBS and need a passport for international business travel?", a: "Fast Passport Center serves JBS and all Weld County business travelers. We understand corporate travel demands and can coordinate expedited passport and visa support services. Multiple employee applications can be processed simultaneously." },
    { q: "Can you help with passports for Evans, Windsor, or other Weld County communities?", a: "Yes. Fast Passport Center serves all Weld County communities including Evans, Windsor, Johnstown, Milliken, La Salle, Eaton, Ault, Severance, Pierce, Kersey, Platteville, and Fort Lupton. Our service works the same way everywhere — ship your documents and we handle the rest." },
    { q: "How much does an expedited passport cost in Greeley, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Greeley?", a: "Walgreens (2712 W 10th St and 3540 W 10th St) and CVS (2624 11th Ave) offer passport photo services in Greeley. The UPS Store at 4407 Centerplace Dr also provides passport photos. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "What's the closest major airport for international flights from Greeley?", a: "Denver International Airport (DIA) is the primary international airport for Greeley travelers — approximately 60 miles south via US-85 and E-470. DIA offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations." },
  ],
  photoLocations: [
    { name: "Walgreens — West Greeley", address: "2712 W 10th St, Greeley, CO 80634", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walgreens — Central Greeley", address: "3540 W 10th St, Greeley, CO 80634", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Greeley", address: "2624 11th Ave, Greeley, CO 80631", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Centerplace", address: "4407 Centerplace Dr, Greeley, CO 80634", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Greeley (Weld County)", address: "2320 Reservoir Rd, Greeley, CO 80631", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Weld County residents. REAL ID and driver's license renewals. Convenient central Greeley location.", featured: true },
    { name: "DMV — Fort Collins (Larimer County)", address: "3030 S College Ave, Fort Collins, CO 80525", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for western Weld County residents near the Larimer County line. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "60 miles south of Greeley via US-85 and E-470",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Approximately 1 hour 15 minutes from Greeley.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "FNL",
      name: "Northern Colorado Regional Airport",
      distance: "25 miles west of Greeley via US-34",
      address: "4900 Earhart Rd, Loveland, CO 80538",
      note: "Regional airport serving Fort Collins and Loveland with limited commercial service. Convenient for private and general aviation. No international flights.",
      flightUrl: "https://www.flynoco.com/",
      flightLabel: "FNL Flight Info",
      featured: false,
    },
  ],
};